// mobile sticky add to cart bar

document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("sticky-add-to-cart-mobile");
  let lastScrollTop = 0;

  window.addEventListener("scroll", () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 400) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        stickyBar.classList.add("sticky-add-to-cart--visible");
      } else {
        // Scrolling up
        stickyBar.classList.add("sticky-add-to-cart--visible");
      }
    } else {
      // At the top of the page
      stickyBar.classList.remove("sticky-add-to-cart--visible");
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  });
});

// desktop sticky add to cart bar
document.addEventListener("DOMContentLoaded", () => {
  const stickyBar = document.getElementById("sticky-add-to-cart-desktop");
  let lastScrollTop = 0;

  window.addEventListener("scroll", () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > 500) {
      if (scrollTop > lastScrollTop) {
        // Scrolling down
        stickyBar.classList.add("sticky-add-to-cart--visible");
      } else {
        // Scrolling up
        stickyBar.classList.add("sticky-add-to-cart--visible");
      }
    } else {
      // At the top of the page
      stickyBar.classList.remove("sticky-add-to-cart--visible");
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop; // For Mobile or negative scrolling
  });
});
